<div class="login-wrapper">
  <mat-card class="login-card">
    <mat-card-header>
      <mat-card-title>Bem vindo de volta</mat-card-title>
      <mat-card-subtitle class="subtitle-spacing">Insira suas credenciais para logar novamente</mat-card-subtitle>
    </mat-card-header>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <!-- Email Field -->
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Email</mat-label>
        <input
          matInput
          formControlName="email"
          placeholder="Digite seu email"
          type="email"
          autocomplete="username"
        />
        <mat-error *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
          {{ getEmailErrorMessage() }}
        </mat-error>
      </mat-form-field>

      <!-- Password Field -->
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Senha</mat-label>
        <input
          matInput
          [type]="hidePassword ? 'password' : 'text'"
          formControlName="password"
          placeholder="Digite sua senha"
          autocomplete="current-password"
        />
        <button
          mat-icon-button
          matSuffix
          (click)="togglePasswordVisibility()"
          type="button"
          aria-label="Toggle password visibility"
        >
          <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-error *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
          Senha é obrigatória
        </mat-error>
      </mat-form-field>

      <!-- Actions -->
      <div class="actions">
        <mat-checkbox formControlName="rememberMe">Lembrar dados</mat-checkbox>
        <a class="forgot-password-link" routerLink="/forgot-password">Esqueceu sua senha?</a>
      </div>

      <!-- Login Button -->
      <button
        mat-raised-button
        color="primary"
        class="full-width login-button"
        [disabled]="loginForm.invalid"
      >
        Acessar
      </button>
    </form>

    <mat-card-actions align="end">
      <a routerLink="/register" class="register-link">Criar conta</a>
    </mat-card-actions>
  </mat-card>
</div>